import { render, staticRenderFns } from "./AttentionsByTypeHeader.vue?vue&type=template&id=a7371b7c&scoped=true&"
import script from "./AttentionsByTypeHeader.vue?vue&type=script&lang=js&"
export * from "./AttentionsByTypeHeader.vue?vue&type=script&lang=js&"
import style0 from "./AttentionsByTypeHeader.vue?vue&type=style&index=0&id=a7371b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7371b7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a7371b7c', component.options)
    } else {
      api.reload('a7371b7c', component.options)
    }
    module.hot.accept("./AttentionsByTypeHeader.vue?vue&type=template&id=a7371b7c&scoped=true&", function () {
      api.rerender('a7371b7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base/AttentionsByTypeHeader.vue"
export default component.exports